import * as d3 from 'd3';
import _ from 'lodash';
import { Granularity } from '../../models';
import React from 'react';
import { IChartTimeline } from './models';
import { ChartConstants, createScales, getDateFormat, getInterval } from './util';
import * as S from './x-axis.styles';

export interface IXAxisProps {
    chartRect: ClientRect;
    granularity: Granularity;
    timeline: IChartTimeline;
}

export class XAxis extends React.Component<IXAxisProps> {
    public render(): React.ReactElement {
        const { chartRect, granularity, timeline } = this.props;
        const interval = getInterval(granularity);
        const [xScale] = createScales(timeline, granularity, chartRect);
        const [startDate, endDate] = xScale.domain();

        const yearFmt = d3.utcFormat('%Y');
        const dateFmt = getDateFormat(granularity);

        const xAxisInterval = [startDate, interval.offset(endDate, 1)];
        const xAxisTickCount = interval.count(xAxisInterval[0], xAxisInterval[1]);
        const xAxisTickStep = xAxisTickCount > 7 ? xAxisTickCount / 7 : 1;
        const xAxisTickDates = interval.range(xAxisInterval[0], xAxisInterval[1], xAxisTickStep);
        const labels = _.map(xAxisTickDates, (date: Date) => {
            return (
                <S.XAxisGroup key={date.getTime()} transform={`translate(${xScale(date)},0)`}>
                    <S.XAxisLabel dy="0.71em" y={7}>
                        {dateFmt(date)}
                    </S.XAxisLabel>
                </S.XAxisGroup>
            );
        });

        const endLabelOffset = ChartConstants.xAxisLabelHeight;
        return (
            <S.XAxis transform={`translate(0, ${chartRect.bottom})`} textAnchor="middle">
                {labels}
                <S.XAxisGroup transform={`translate(${xScale(startDate)},${endLabelOffset})`}>
                    <S.XAxisLabel dy="0.71em" y={8}>
                        {yearFmt(startDate)}
                    </S.XAxisLabel>
                </S.XAxisGroup>
                <S.XAxisGroup transform={`translate(${xScale(endDate)},${endLabelOffset})`}>
                    <S.XAxisLabel dy="0.71em" y={8}>
                        {yearFmt(endDate)}
                    </S.XAxisLabel>
                </S.XAxisGroup>
            </S.XAxis>
        );
    }
}
